import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AmusementGroup`;

const ApiAmusementGroup = {
  getAmusementGroups: (params) => {
    
    const url = `${baseServiceUrl}`;
    
    return ServiceApi.get(url, { params });
  },
};

export default ApiAmusementGroup;
